import cn from 'classnames';
import style from './Wrapper.module.scss';

const Wrapper = ({ children, className }) => {
  const wrapperClassName = cn(style.wrapper, className);

  return <div className={wrapperClassName}>{children}</div>;
};

export default Wrapper;
